export default __webpack_public_path__ + "static/media/scryptictech.e52e64e7.svg";